// extracted by mini-css-extract-plugin
export default {"search_input":"searchInput_search_input__EYeeN","input":"searchInput_input__4Tkj2","icon":"searchInput_icon__oySho","iconPath":"searchInput_iconPath__0ySmm"};